"use client"

import styled from "@emotion/styled"
import { useTranslations } from "next-intl"
import { LandingFormSide, LandingSlider } from ".."

const StyledLandingLayout = styled.div`
  * {
    font-family: var(--ploni) !important;
  }
  ${(props) => props.theme.breakpoints.up("md")} {
    display: grid;
    grid-template-columns: 1fr 480px;
    min-height: 100vh;
    & > * {
      height: 100%;
    }
  }
`

type Props = {
  locale: string
  data: any
  companyId?: number
  companyName?: string
  messages?: { learnMore: string; followUs: string; learnMoreAbout: string }
}

export const LandingPage: React.FC<Props> = ({ data, locale }: Props) => {
  const t = useTranslations("LandingPage")
  const formMessages = {
    contactUs: t("contactUs"),
    toProject: t("toProject"),
    leaveDetails: t("leaveDetails"),
    forYou: t("forYou"),
    required: t("required"),
    fullName: t("fullName"),
    telephone: t("telephone"),
    email: t("email"),
    send: t("send"),
    sucessTitle: t("sucessTitle"),
    sucessText: t("sucessText"),
    contactSucessTitle: t("contactSucessTitle"),
    contactSucessText: t("contactSucessText"),
  }

  const scrollDownToForm = () => {
    const element = document.getElementById("landingLeadForm")
    if (element) {
      const rect = element.getBoundingClientRect()
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop
      const elementCenterY = rect.top + scrollTop + rect.height / 2
      const targetScrollTop = elementCenterY - window.innerHeight / 2

      window.scrollTo({ top: targetScrollTop, behavior: "smooth" })
    }
  }

  return (
    <StyledLandingLayout>
      <LandingSlider data={data.page} locale={locale} scrollDownToForm={scrollDownToForm} />
      <LandingFormSide data={data.page} locale={locale} messages={formMessages} />
    </StyledLandingLayout>
  )
}

export default LandingPage
